import { call, fork, select, takeLatest } from 'redux-saga/effects';

import ProgressAPI from '../api/ProgressAPI';
import { BUILDER_SEND } from '../constants/actionTypes';
import { accessTokenSelector, builderSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* progressSendWatcher() {
  yield takeLatest(BUILDER_SEND, progressSendWorker);
}

function* progressSendWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const builder = yield select(builderSelector);
    const { id } = builder.server;
    yield call(
      ProgressAPI.sendProgress,
      { applicationId: id, builder: JSON.stringify(builder) },
      accessToken,
    );
    // maybe trigger a success and log something in the store (last time of save, maybe?)
  } catch (error) {
    yield fork(manageAPIError, { ...error, action });
  }
}

export { progressSendWorker };
export default progressSendWatcher;
